<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('batchSales')">Lotti</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Crea
    </h1>
    <div class="bg-white rounded-md shadow max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.nome" :error="form.errors.nome" class="pr-6 pb-8 w-full lg:w-1/2" label="Nome Lotto" />
          <multiselect v-model="selectedOrganization" id="organization_id" placeholder="Cerca store" :options="organizations" label="name" track-by="id" @search-change="onSearchOrganizationsChange" @input="onSelectedOrganization" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Crea Vendita di un Lotto</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import { StreamBarcodeReader } from 'vue-barcode-reader'
import Multiselect from 'vue-multiselect'

export default {
  metaInfo: { title: 'Create Batch' },
  components: {
    LoadingButton,
    SelectInput,
    StreamBarcodeReader,
    TextInput,
    Multiselect,
  },
  layout: Layout,
  props: {
    organizations: Object,
  },
  remember: 'form',
  data() {
    return {
      selectedOrganization: undefined,
      form: this.$inertia.form({
        nome: null,
        organization_id: null,
      }),
    }
  },
  methods: {
    store() {
      if (navigator.onLine) {
        this.form.post(this.route('batchSales.store')), this.form.reset('nome'), this.form.focus('nome')
      } else {
        this.$page.props.flash.error = 'Controllare la connessione e ricaricare la pagina'
      }
    },
    onDecode(text) {
      console.log(`Decode text from QR code is ${text}`)
    },
    onLoaded() {
      console.log(`Ready to start scanning barcodes`)
    },
    onSearchOrganizationsChange(term) {
        this.$inertia.get('/organizations/getOrganizations', {term}, {
            preserveState: true,
            preserveScroll: true,
            replace: true
        })
    },
    onSelectedOrganization(organization) {
    this.form.organization_id = organization.id;
    },
  }
}
</script>
